/**
 * @generated SignedSource<<877dfa62b9ef93692d02178709546477>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type moreButton_softwareReleasesVersionDetailIssueList_jiraIssue$data = {
  readonly key: string;
  readonly " $fragmentSpreads": FragmentRefs<"ui_softwareReleasesMoveIssuesBetweenVersions_MoveIssuesBetweenVersions_jiraIssue">;
  readonly " $fragmentType": "moreButton_softwareReleasesVersionDetailIssueList_jiraIssue";
};
export type moreButton_softwareReleasesVersionDetailIssueList_jiraIssue$key = {
  readonly " $data"?: moreButton_softwareReleasesVersionDetailIssueList_jiraIssue$data;
  readonly " $fragmentSpreads": FragmentRefs<"moreButton_softwareReleasesVersionDetailIssueList_jiraIssue">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "moreButton_softwareReleasesVersionDetailIssueList_jiraIssue",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ui_softwareReleasesMoveIssuesBetweenVersions_MoveIssuesBetweenVersions_jiraIssue"
    },
    {
      "kind": "ScalarField",
      "name": "key"
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "fd443315ecfab8b84a64de9bab079996";

export default node;
